import React from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel, user as userModel } from '@/models';
import { WhiteboardAuth } from '@/types/whiteboard';

export interface WhiteboardInfoResp {
  whiteboardOwnerDeviceId: string;
  whiteboardOwnerUid: string;
  yxAuth: WhiteboardAuth;
  state: number;
}

export default function useWhiteboardInfoChange() {
  const { user, meeting } = useLocalStore(() => {
    return {
      user: userModel,
      meeting: meetingModel,
    };
  });
  const { formatMessage } = useIntl();

  const change = async (body: WhiteboardInfoResp) => {
    const { state, whiteboardOwnerUid, whiteboardOwnerDeviceId, yxAuth } = body;
    if (whiteboardOwnerUid !== user.uid) {
      if (state === 1) {
        meeting.setWhiteboardWillClose(false);
        meeting.setWhiteboardUid(
          whiteboardOwnerUid + whiteboardOwnerDeviceId,
          yxAuth,
          yxAuth.whiteboardChannelId
        );
        meeting.setWhiteboardLoading(true);
        message.info({
          className: 'Bj8Ya1FPM9',
          content: (
            <span className="text">
              <span className="ellipsis">{meeting?.getMemberInfoByUid(body.uid)?.memberName}</span>
              <span>{formatMessage({ id: 'WHITEBOARD_OPENED' })}</span>
            </span>
          ),
          duration: 2,
          noIcon: true,
        });
      } else {
        meeting.setWhiteboardUid('', undefined, '');
      }
    }
  };

  return change;
}
